import { round } from 'lodash-es'

/**
 * 비율 계산
 * @example calcPercent(30, 200) => 15
 * @example calcPercent(0, 0) => 0
 */
export function calcPercent(
  value: number,
  total: number,
  decimals: number = 0
): number {
  if (total === 0) return 0
  return toFixedNumber((value / total) * 100, decimals)
}

/**
 * 증감률 계산
 * @example calcChange(100, 130) => 30
 * @example calcChange(100, 70) => -30
 * @example calcChange(0, 50) => 0
 */
export function calcChange(
  prev: number,
  current: number,
  decimals: number = 1
): number {
  if (prev === 0) return 0
  return toFixedNumber(((current - prev) / prev) * 100, decimals)
}

/**
 * 부동소수점 안전 반올림
 * - `0.1 + 0.2 = 0.30000000000000004` 방지
 *
 * @example toFixedNumber(3.14159, 2) => 3.14
 * @example toFixedNumber(0.1 + 0.2, 1) => 0.3
 */
export function toFixedNumber(value: number, decimals: number): number {
  return round(value, decimals)
}
